
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deployPipeline",
      resolverType: "mutation",
      routePath: "/deployPipeline",
      httpMethod: "POST",
    });
  